export enum BackendEndpoints {
    API = 'api',
    CARS = 'cars',
    DEALER = 'dealer',
    DEALERS = 'dealers',
    PROVINCES = 'provinces',
    V1 = 'v1',
    V2 = 'v2',
}
